import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { ProviderImportPage } from '@/features/subscriptions'

export const Route = createFileRoute('/_authenticated/subscriptions/providers')(
  {
    component: () => (
      <RequirePermission permission='providers.update'>
        <ProviderImportPage />
      </RequirePermission>
    ),
  }
)
